<template>
  <b-form-group
    :id="formGroupId"
    :label="label"
    :label-for="id"
    label-class="label-bold"
    :invalid-feedback="errorMsg"
    :state="state"
  >
    <p class="form-text text-secondary px-3 pb-1 m-0">
      If no province, enter 'none'
    </p>
    <b-input-group>
      <b-form-input
        :id="id"
        :maxlength="maxlength"
        :placeholder="placeholder"
        @input="$emit('province-value-input', modifiedProvince)"
        v-model="province"
        :state="state"
        trim
        :disabled="isDisabled"
      ></b-form-input>
    </b-input-group>
  </b-form-group>
</template>

<script>
// v-model="province"

export default {
  name: 'ProvinceField',
  props: [
    'id',
    'label',
    'placeholder',
    'maxlength',
    'state',
    'errorMsg',
    'disabled',
    'init',
  ],
  data: function () {
    return {
      province: this.initialize(),
    };
  },
  computed: {
    formGroupId: function () {
      return this.id + '-group';
    },
    isDisabled: function () {
      return this.disabled;
    },
    modifiedProvince: {
      get: function () {
        // If value of province matches the word 'none', with/without single quotes, case-insensitive, force its value to be: none
        // (lowercase WITHOUT quotes)
        if (/^['"]?none['"]?$/i.test(this.province)) {
          return 'none';
        } else {
          return this.province;
        }
      },
      set: function (val) {
        console.log(val);
        return val;
      },
    },
  },
  methods: {
    initialize: function () {
      this.$emit('province-value-input', this.init || '');
      return this.init || '';
    },
  },

  // created: function () {
  //   this.province = this.init || '';
  //   this.$emit('province-value-input', this.modifiedProvince);
  // },
};
</script>

<style>
</style>